module.exports = __webpack_public_path__ + "static/media/crane8.0ed9d97e.png";